// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"489":"69144b365fbe76fac05f","506":"e783a84437a084272e4b"}[chunkId] + ".js";
};